import { useMemo } from 'react';

export const usePassword = ({ firstLogin, isPasswordForce, hasPassword }) => {
    const result = useMemo(() => {
        const shouldSetPassword = isPasswordForce && !hasPassword;
        const canLoginWithPassword = isPasswordForce && hasPassword;

        return {
            shouldSetPassword,
            canLoginWithPassword,
        };
    }, [firstLogin, isPasswordForce, hasPassword]);

    return result;
};
